import { styled } from '@mui/material/styles'
import { IMessage } from '@weblite/ts-action/message'
import { FileMessageIcon } from '$common/icons/file-message'
import { WappMessageIcon } from '$common/icons/wapp-message'
import { PhotoMessageIcon } from '$common/icons/photo-message'
import { VoiceMessageIcon } from '$common/icons/voice-message'
import { VideoMessageIcon } from '$common/icons/video-message'
import { AudioMessageIcon } from '$common/icons/audio-message'
import { ContactIcon } from '$common/icons'

const Container = styled('div')`
  margin-left: 4px;
  display: flex;
`

const ContactMessageIcon = styled(ContactIcon)(({ theme }) => ({
  color: theme.palette.gray,
  width: '16px',
  height: '16px',
}))

const typeIconMapper: Record<IMessage['type'], React.ElementType | null> = {
  FILE: FileMessageIcon,
  WAPP: WappMessageIcon,
  IMAGE: PhotoMessageIcon,
  VOICE: VoiceMessageIcon,
  VIDEO: VideoMessageIcon,
  AUDIO: AudioMessageIcon,
  CONTACT: ContactMessageIcon,
  EVENT: null,
  TEXT: null,
  CALL: null,
}

interface Props {
  type: IMessage['type']
}

export function MessageType({ type }: Props) {
  const IconComponent = typeIconMapper[type]

  return IconComponent ? (
    <Container>
      <IconComponent />
    </Container>
  ) : null
}
